let id = 0;

export default function nextId(){
	return ++id;
}


// WEBPACK FOOTER //
// ./src/services/NextID.service.js